import { z } from 'zod';
import { ALL_ROLES } from '../constants/roles.js';

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email('Enter a valid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters').max(128),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const authUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().email(),
  role: z.enum(ALL_ROLES as [string, ...string[]]),
});

export type AuthUser = z.infer<typeof authUserSchema>;

export const authSessionSchema = z.object({
  user: authUserSchema,
  accessToken: z.string(),
  accessTokenExpiresAt: z.string(),
});

export type AuthSession = z.infer<typeof authSessionSchema>;

/**
 * Consumes an admin/HR-triggered password-reset link — `token` is the raw,
 * single-use bearer secret mailed to the employee (see
 * `server/src/utils/passwordResetToken.ts`), never the record's id.
 */
export const resetPasswordSchema = z.object({
  token: z.string().min(1, 'Reset token is required'),
  newPassword: z.string().min(8, 'Password must be at least 8 characters').max(128),
});

export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
